import { createFileRoute } from '@tanstack/react-router'

import Styles from 'pages/Styles'

export const Route = createFileRoute('/styles')({
  component: Styles,
})
